import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FabricService } from '../../services/fabric.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FabricItemBaseComponent } from '../shared/fabric-item-base.directive';
import { FabricItem } from '../../models/FabricItem';

@Component({
  selector: 'app-pipelines',
  standalone: true,
  imports: [CommonModule, FormsModule, MatProgressSpinnerModule],
  templateUrl: './pipelines.component.html',
  styleUrl: '../shared/fabric-item-base.directive.scss',
})
export class PipelinesComponent extends FabricItemBaseComponent {
  protected get itemType(): string {
    return 'pipeline';
  }

  protected get jobType(): string {
    return 'Pipeline';
  }

  get pipelines(): FabricItem[] {
    return this.items;
  }

  get selectedPipeline(): FabricItem | null {
    return this.selectedItem;
  }

  set selectedPipeline(value: FabricItem | null) {
    this.selectedItem = value;
  }

  get filteredPipelines() {
    return this.filteredItems;
  }

  selectPipeline(pipeline: FabricItem) {
    this.selectItem(pipeline);
  }

  runPipeline(id: string) {
    this.runItem(id);
  }

  savePipeline() {
    this.saveItem();
  }

  editPipeline() {
    this.editItem();
  }

  constructor(fabricService: FabricService) {
    super(fabricService);
  }

  protected override extractParameterFields(params: any) {
    Object.entries(params).forEach(([key, details]: [string, any]) => {
      const field = {
        label: key,
        type: details.type || 'string',
        value: details.defaultValue || ''
      };
      if(field.label === 'pipeline_trigger_time') {
        field.value = new Date().toISOString();
      }
      this.parameterFields.push(field);
    });
  }
}
